module.exports = __webpack_public_path__ + "css/OceanVolt.e4ddd5ba.css";